module.exports = __webpack_public_path__ + "img/bs_silo_4.6140ecd6.png";